import { render, staticRenderFns } from "./CompensationTypes.vue?vue&type=template&id=f3166446&scoped=true&"
import script from "./CompensationTypes.vue?vue&type=script&lang=js&"
export * from "./CompensationTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3166446",
  null
  
)

export default component.exports